import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import logo1  from "../assets/logo1.png"; 

export default function Footer() {
  return (
    <footer className="bg-[#0b0a1e] text-white py-10 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
        <div>
          <img src={logo1 } alt="Atronm Logo" className="w-32 mb-4" loading="lazy" decoding="async" />
          <p className="mb-4 text-sm leading-relaxed">
            Turning sparks into Tech
          </p>
          <div className="flex gap-3 text-lg">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF className="hover:text-pink-400" /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter className="hover:text-pink-400" /></a>
            <a href="https://www.instagram.com/atronm_technologies/" target="_blank" rel="noopener noreferrer"><FaInstagram className="hover:text-pink-400" /></a>
            <a href="https://www.linkedin.com/company/atronm/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn className="hover:text-pink-400" /></a>
          </div>
        </div>

        <div>
          <h3 className="text-xl font-semibold mb-4">Services</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services/ai" className="hover:text-pink-400">AI and Machine Learning</Link></li>
            <li><Link to="/services/app" className="hover:text-pink-400">App Development</Link></li>
            <li><Link to="/services/cloud" className="hover:text-pink-400">Cloud & DevOps</Link></li>
            <li><Link to="/services/custom" className="hover:text-pink-400">Custom Software</Link></li>
            <li><Link to="/services/web" className="hover:text-pink-400">Web Development</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-xl font-semibold mb-4">Company</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-pink-400">About Us</Link></li>
            <li><Link to="/careers" className="hover:text-pink-400">Careers</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-xl font-semibold mb-4">Get in Touch</h3>
          <a href="tel:+923354032233" className="flex items-center gap-2 mb-2 text-sm hover:text-pink-400">
            <FaPhoneAlt /> +92 335 4032233
          </a>
          <a href="mailto:contact@atronm.com" className="flex items-center gap-2 mb-2 text-sm hover:text-pink-400">
            <FaEnvelope /> contact@atronm.com
          </a>
          <p className="text-sm mb-2">Lahore, Pakistan</p>
        </div>

        <div>
          <h3 className="text-xl font-semibold mb-4">Join Our Newsletter</h3>
          <form className="flex flex-col gap-2">
            <input
              type="email"
              placeholder="Your Email"
              className="px-4 py-2 rounded-md text-black focus:outline-none"
            />
            <button
              type="submit"
              className="bg-pink-500 text-white rounded-md py-2 hover:bg-pink-600"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

      <div className="mt-10 border-t border-gray-600 pt-4 text-sm text-center">
        &copy; {new Date().getFullYear()} Atronm. All rights reserved.
      </div>
    </footer>
  );
}
